export default "__VITE_ASSET__BTr6a3U0__"